import { render, staticRenderFns } from "./eidt-manage-make-dialog.vue?vue&type=template&id=4797b454&scoped=true&"
import script from "./eidt-manage-make-dialog.vue?vue&type=script&lang=js&"
export * from "./eidt-manage-make-dialog.vue?vue&type=script&lang=js&"
import style0 from "./eidt-manage-make-dialog.vue?vue&type=style&index=0&id=4797b454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797b454",
  null
  
)

export default component.exports